import { render, staticRenderFns } from "./DisplayTextComponent.vue?vue&type=template&id=8cab91ea&scoped=true&"
import script from "./DisplayTextComponent.vue?vue&type=script&lang=js&"
export * from "./DisplayTextComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cab91ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
